module.exports = "a {\r\n    cursor: pointer;\r\n}\r\n\r\n.help-block {\r\n    font-size: 12px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.css
// module id = ./src/assets/app.css
// module chunks = main